const formatDate = datestring => {
    const dateobject = datestring
        ? new Date(datestring)
        : new Date();
    return new Intl.DateTimeFormat('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour12: true,
        minute: '2-digit',
        hour: '2-digit',
        hourcycle: "h12",
    }).format(dateobject);
};

const downloadableResponseHandler = (response, errorHandler) => {
    const isValidResponse = (r => {
        return !!r && !!r.data &&
            r.data.hasOwnProperty('fileContents') &&
            r.data.hasOwnProperty('contentType') &&
            r.data.hasOwnProperty('fileDownloadName');
    })(response);

    if (!isValidResponse) {
        errorHandler?.('There was a problem fetching your requested file');
        return;
    }
    const hl = document.createElement('a');
    hl.href = `data:application/octet-stream;base64,${response.data.fileContents}`;
    hl.target = '_blank';
    hl.download = response.data.fileDownloadName;
    hl.click();
}

export { formatDate, downloadableResponseHandler }; 